@if (title) {
<h3 class="h4 text-center mx-auto" [attr.data-e2e]="e2e + '-title'" [class.mb-1]="subTitle">{{ title }}</h3>
} @if (subTitle) {
<p class="lead text-mw text-center mx-auto" [attr.data-e2e]="e2e + '-subTitle'">{{ subTitle }}</p>
}

<div class="row" [attr.data-e2e]="e2e + '-items'">
  @for (item of items; track item; let index = $index; let isOdd = $odd) {
  <div class="col-12 col-md-5 col-xxl-4" [ngClass]="{'offset-md-1 offset-xxl-0': isOdd}">
    <div
      class="card ob1-push ob1-push-shadow-right ob1-push-md-shadow-left"
      [class.ob1-push-no-interaction]="!item.link"
    >
      <div class="card-header">
        <img
          class="card-img-top"
          [alt]="item.image.alt"
          [attr.data-e2e]="e2e + '-items-' + index + '-image'"
          [src]="item.image.url"
        />
      </div>

      <div class="card-body">
        <h4 class="card-title" [attr.data-e2e]="e2e + '-items-' + index + '-title'">{{ item.title }}</h4>
        <p class="card-text" [attr.data-e2e]="e2e + '-items-' + index + '-content'" [innerHTML]="item.description"></p>

        @if (item.link; as link) {
        <p class="py-0 card-btn">
          <a
            [attr.data-e2e]="e2e + '-items-' + index + '-link'"
            [href]="link.url"
            class="btn btn-secondary"
            (click)="clickWidgetButton.emit(index)"
            >{{ link.label }}</a
          >
        </p>
        }
      </div>
    </div>
  </div>
  }
</div>
